export const PARTNER_TYPE_LIST = {
  ValueByTypeList: [
    {
      name: 'Aereo',
      value: 'Aéreo',
      description: 'Par de valores Port. / Ingles',
    },
    {
      name: 'Claro',
      value: 'Claro',
      description: null,
    },
    {
      name: 'Combustível',
      value: 'Combustível',
      description: null,
    },
    {
      name: 'Financeiro',
      value: 'Financeiro',
      description: 'Par de valores Port. / Ingles',
    },
    {
      name: 'Hotéis',
      value: 'Hotéis',
      description: 'Par de valores Port. / Ingles',
    },
    {
      name: 'Ingressos',
      value: 'Ingressos',
      description: null,
    },
    {
      name: 'Nao Aereo',
      value: 'Não Aéreo',
      description: 'Par de valores Port. / Ingles',
    },
    {
      name: 'Outros',
      value: 'Outros',
      description: null,
    },
    {
      name: 'Restaurantes',
      value: 'Restaurantes',
      description: 'Par de valores Port. / Ingles',
    },
    {
      name: 'Seguro Viagem',
      value: 'Seguro Viagem',
      description: null,
    },
    {
      name: 'Shopping Smiles e Carros',
      value: 'Shopping Smiles e Carros',
      description: null,
    },
    {
      name: 'Smiles',
      value: 'Smiles',
      description: null,
    },
    {
      name: 'Transferência Bancos Parceiros',
      value: 'Transferência Bancos Parceiros',
      description: null,
    },
    {
      name: 'Turismo',
      value: 'Turismo',
      description: null,
    },
    {
      name: 'Uber',
      value: 'Uber',
      description: null,
    },
    {
      name: 'Voos',
      value: 'Voos',
      description: null,
    },
    {
      name: 'Wine',
      value: 'Wine',
      description: null,
    },
  ],
  metaInformation: {
    pagination: {
      page: 1,
      quantity: 17,
      total: 17,
    },
  },
};

export const REFINED_PARTNER_TYPE_LIST = [
  {
    name: 'Aereo',
    value: 'Aéreo',
    id: 'AEREO',
    description: 'Par de valores Port. / Ingles',
  },
  {
    name: 'Claro',
    value: 'Claro',
    id: 'CLARO',
  },
  {
    name: 'Combustível',
    value: 'Combustível',
    id: 'COMBUSTIVEL',
  },
  {
    name: 'Financeiro',
    value: 'Financeiro',
    id: 'FINANCEIRO',
    description: 'Par de valores Port. / Ingles',
  },
  {
    name: 'Hotéis',
    value: 'Hotéis',
    id: 'HOTEIS',
    description: 'Par de valores Port. / Ingles',
  },
  {
    name: 'Ingressos',
    value: 'Ingressos',
    id: 'INGRESSOS',
  },
  {
    name: 'Nao Aereo',
    value: 'Não Aéreo',
    id: 'NAO_AEREO',
    description: 'Par de valores Port. / Ingles',
  },
  {
    name: 'Outros',
    value: 'Outros',
    id: 'OUTROS',
  },
  {
    name: 'Restaurantes',
    value: 'Restaurantes',
    id: 'RESTAURANTES',
    description: 'Par de valores Port. / Ingles',
  },
  {
    name: 'Seguro Viagem',
    value: 'Seguro Viagem',
    id: 'SEGURO_VIAGEM',
  },
  {
    name: 'Shopping Smiles e Carros',
    value: 'Shopping Smiles e Carros',
    id: 'SHOPPING_SMILES_E_CARROS',
  },
  {
    name: 'Smiles',
    value: 'Smiles',
    id: 'SMILES',
  },
  {
    name: 'Transferência Bancos Parceiros',
    value: 'Transferência Bancos Parceiros',
    id: 'TRANSFERENCIA_BANCOS_PARCEIROS',
  },
  {
    name: 'Turismo',
    value: 'Turismo',
    id: 'TURISMO',
  },
  {
    name: 'Uber',
    value: 'Uber',
    id: 'UBER',
  },
  {
    name: 'Voos',
    value: 'Voos',
    id: 'VOOS',
  },
  {
    name: 'Wine',
    value: 'Wine',
    id: 'WINE',
  },
];
